// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import angular from "angular"

const app = angular.module('summonApp', [
   'ngRoute',
   'ngAnimate',
   'ngSanitize',
   'ngCookies',
   'summonApp.services',
   'summonApp.factories',
   'summonApp.controllers',
   'summonApp.directives',
   'summonApp.filters',
   'summonApp.constants',
   'summonApp.values',
   'summonApp.urlRewriter',
   'summonApp.animations',
   'summonApp.syndetics',
   'summonApp.custom',
   // plugins
   'summonApp.resultsFeedPlugins',
   // third-party
   'ui.bootstrap',
   'colorpicker.module',
   'jsonFormatter',
   'ngToast'
])

// exported so it can be exercised directly in specs without bootstrapping the Angular injector
export const resourceUrlWhitelist = [
   'self',
   /htt(p|ps):\/\/.*(-|\.)summon(-|\.)serialssolutions(-|\.)com((\..*){0,}\.(oclc\.org|edu)){0,1}\/.*/,
   /https:\/\/(\d+-){0,1}fusion(-|\.)endnote(-|\.)com((\..*){0,}\.(oclc\.org|edu)){0,1}\/.*/,
   // kept for backward compatibility while RefWorks links redirect to EndNote Fusion
   /https:\/\/(\d+-){0,1}refworks(-|\.)proquest(-|\.)com((\..*){0,}\.(oclc\.org|edu)){0,1}\/.*/
]

class AppConfig {
   constructor($routeProvider: any, $locationProvider: any, $anchorScrollProvider: any, $sceDelegateProvider: any, $uibTooltipProvider: any, $compileProvider: any, $httpProvider: any, $logProvider: any, ngToastProvider: any) {
      // add whitelisted URLs
      $sceDelegateProvider.resourceUrlWhitelist(resourceUrlWhitelist)

      $uibTooltipProvider.setTriggers({
         'customEvent': 'customEvent'})

      ngToastProvider.configure({
         animation: 'fade',
         horizontalPosition: 'center',
         verticalPosition: 'top',
         dismissButton: true,
         timeout: 5000
      })

      // not quite sure this works, but adding it nonetheless
      $anchorScrollProvider.disableAutoScrolling()
      $locationProvider.html5Mode(false)

      // hide debug info, should improve perfomance
      // $compileProvider.debugInfoEnabled(false)
      // https://docs.angularjs.org/api/ng/provider/$compileProvider#debugInfoEnabled
      $compileProvider.commentDirectivesEnabled(false)
    
      // set on develop, or if param on URL (handy for prod debugging)
      // @ts-expect-error TS(2339) FIXME: Property '__configData' does not exist on type 'Wi... Remove this comment to see the full error message
      const env = window.__configData && window.__configData.info && window.__configData.info.env ? window.__configData.info.env : 'unknown'
    
      // this sets the scrollbar width CSS variable on startup, we will refresh it when needed - especially needed for dialog opening
      // the dialog opens and sets overflow:hidden, so the scrollbar disappears, but that shifts the layout a bit. This can be compensated by setting margin to scrollbar-size
      document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px')
      // set a default of 0, updated in advancedSearchController.js.coffee
      document.documentElement.style.setProperty('--advanced-selected-facets-height', '0px')

      $logProvider.debugEnabled((env === 'development') || (window.location.hash && (window.location.hash.indexOf('debuglog=true') > -1)))
    
      // @ts-expect-error TS(2339) FIXME: Property '__configData' does not exist on type 'Wi... Remove this comment to see the full error message
      if (window.__configData && window.__configData.authentication && window.__configData.authentication.enabled) {
         $httpProvider.interceptors.push('authInterceptor')
      }

      // only open advanced search modal when no query params are present for /advanced#!/ route
      const optionalAdvancedAction = window.document.location.pathname === '/advanced' && ['#!','#!/'].includes(window.document.location.hash)
      
      // NOTE: these routes gets us access to $routeParams for this path in the ApplicationController
      $routeProvider
         .when('/', { redirectTo: optionalAdvancedAction ? '/search' : '/', action: optionalAdvancedAction ? 'advanced' : null })
         .when('/advanced', {redirectTo: '/', action: 'advanced'}) // support legacy links to '/advanced' 
         .when('/:l/advanced/?', {redirectTo: '/', action: 'advanced'})
         .when('/widgets', {})
         .when('/:l/widgets/?', {redirectTo: '/widgets'})
         .when('/diagnostics', {templateUrl: '/assets/diagnostics/index.html'})
         .when('/:l/diagnostics/?', {redirectTo: '/diagnostics'})
         .when('/course_reserves', {action: 'home'})
         .when('/:l/course_reserves', {redirectTo: '/course_reserves'})
         .when('/course_reserves/:course_id', {action: 'detail'})
         .when('/:l/course_reserves/:course_id/?', {redirectTo: '/course_reserves/:course_id'})
         .when('/scope_builder/init/search', {redirectTo: '/scope_builder/search', action: 'advanced'})
         .when('/scope_builder/search', {})
         .when('/:l/scope_builder/search/?', {redirectTo: '/scope_builder/search'})
         .when('/search', {})
         .when('/:l/search/?', {redirectTo: '/search' })
         .when('/search/debug', {templateUrl: '/assets/apiDebugger.html', controller: 'DebugCtrl'})
         .when('/search/document', {})
         .when('/:l/search/document/?', {redirectTo: '/search/document'})
         .when('/search/document/debug', {templateUrl: '/assets/apiDebugger.html', controller: 'DebugCtrl'})
         .when('/search/results', {redirectTo: '/search'})             // supported 1.0 legacy route
         .when('/:l/search/results', {redirectTo: '/search'})          // supported 1.0 legacy route
         .when('/document/show', {redirectTo: '/search/document'})     // supported 1.0 legacy route
         .when('/:l/document/show', {redirectTo: '/search/document'})  // supported 1.0 legacy route
         .when('/:l/library_card', {redirectTo: '/library_card'})
         .when('/library_card', { auth: true, feature: 'sierra' })
         .when('/:l/research_assistant', {redirectTo: '/research_assistant'})
         .when('/research_assistant', {
             auth: true,
             feature: 'research_assistant',
             templateUrl: '/assets/researchAssistant.html',
             resolve: {
                authGuard: ['authenticationService', '$location', function (authenticationService: any, $location: any) {
                   return authenticationService.ensureAuthenticatedRAUser($location.absUrl());
                }]
             }
          })
         .otherwise({redirectTo:'/'})
   }
}

AppConfig.$inject = ['$routeProvider', '$locationProvider', '$anchorScrollProvider', '$sceDelegateProvider', '$uibTooltipProvider', '$compileProvider', '$httpProvider', '$logProvider', 'ngToastProvider']

app.config(AppConfig)

app.run(['$templateCache', 'authenticationService', 'beaconService', 'configService', 'mediaQueryService', function($templateCache: any, authenticationService: any) {
  
      // @ts-expect-error TS(2339) FIXME: Property '__configData' does not exist on type 'Wi... Remove this comment to see the full error message
      if (window.__configData?.authentication?.enabled) {
      // initialize auth service once when active
         authenticationService.init()
      }

      // add templates to cache
      return (() => {
         const result = []
         // @ts-expect-error TS(2339) FIXME: Property '__templates' does not exist on type 'Win... Remove this comment to see the full error message
         for (var name in window.__templates) {
         // @ts-expect-error TS(2339) FIXME: Property '__templates' does not exist on type 'Win... Remove this comment to see the full error message
            var content = window.__templates[name]
            result.push($templateCache.put(name, content))
         }
         return result
      })()
   }
])

// Track the user's last interaction modality so styles can distinguish mouse
// from keyboard. Text inputs always match :focus-visible (even on click), so a
// class on <body> is the only reliable way to keep mouse focus light while
// showing a strong focus ring for keyboard (tab) navigation.
;(function trackInputModality() {
   const setMouse = () => document.body.classList.add('using-mouse')
   const setKeyboard = (e: KeyboardEvent) => {
      if (e.key === 'Tab') { document.body.classList.remove('using-mouse') }
   }
   document.addEventListener('mousedown', setMouse, true)
   document.addEventListener('keydown', setKeyboard, true)
})()
